/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Verdict_Review_BodyInputs */

const cs_import_verdict_review_body = /** @type {(inputs: Import_Verdict_Review_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jsou tu varování nebo shody, které potřebují potvrzení. Projděte plán a pokračujte.`)
};

const en_import_verdict_review_body = /** @type {(inputs: Import_Verdict_Review_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There are warnings or matches that need your confirmation. Check the plan, then continue.`)
};

/**
* | output |
* | --- |
* | "There are warnings or matches that need your confirmation. Check the plan, then continue." |
*
* @param {Import_Verdict_Review_BodyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_verdict_review_body = /** @type {((inputs?: Import_Verdict_Review_BodyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Verdict_Review_BodyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_verdict_review_body(inputs)
	return cs_import_verdict_review_body(inputs)
});